import React from "react";

const DEFAULT_SIZE = 14;

type PropsType = {
  size?: number;
};

const Terminal = ({ size = DEFAULT_SIZE }: PropsType) => {
  return (
    <svg width={`${size}px`} height={`${size}px`} viewBox="0 0 14 13">
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth=".63158"
        fillRule="evenodd"
        transform="translate(.5 0.6)"
      >
        <path d="
        M 0,4.5
        L 0,9
        C 4,9.1 9,9.1 13,9
        L 13,4.5
        C 9,4 4,4 0,4.5
        C 1,0 12,0 13,4.5
        M 10,9.05
        L 10,4.2
        M 7,9.07
        L 7,4.1
        M 7,5.7
        L 10,5.7
        M 7,7.5
        L 10,7.5
        " />
      </g>
    </svg>
  );
};

export default Terminal;
